import { useEffect, useState } from "react";
import api from "./api";

const k = (...keys) => keys.map((key) => ({ key }));
// Standard searches (library). Fields without a key become new AI columns.
export const STANDARD_SEARCHES = [
    { id: "blinds", name: "pr_lib_blinds", fields: k("name", "width", "height", "qty", "motor", "fabric", "color", "side", "cable") },
    { id: "windows", name: "pr_lib_windows", fields: [...k("name", "width", "height", "product", "color"), { key: null, label: "pr_glass" }, { key: null, label: "pr_comments" }] },
    { id: "screen", name: "pr_lib_screen", fields: k("name", "width", "height", "fabric", "motor", "side") },
    { id: "mounting", name: "pr_lib_mounting", fields: k("name", "mounting", "borring", "cable") },
    { id: "full", name: "pr_lib_full", full: true, fields: k("name", "width", "height", "qty", "product", "fabric", "color", "side", "motor", "cable", "mounting", "borring", "other") },
];

export function useAiTemplates() {
    const [list, setList] = useState([]);
    useEffect(() => { api.get("/ai/prompt-templates").then((r) => setList(r.data || [])).catch(() => {}); }, []);
    const save = async (name, prompt, fields) => {
        const { data } = await api.post("/ai/prompt-templates", { name, prompt, fields: fields.map(({ key, label }) => ({ key, label })) });
        setList((l) => [...l, data]);
        return data;
    };
    const remove = async (id) => { await api.delete(`/ai/prompt-templates/${id}`); setList((l) => l.filter((x) => x.id !== id)); };
    return { list, save, remove };
}
